export const SEND_BULK_PUSH_NOTIFICATION_START =
  'SEND_BULK_PUSH_NOTIFICATION_START';
export const SEND_BULK_PUSH_NOTIFICATION_SUCCESS =
  'SEND_BULK_PUSH_NOTIFICATION_SUCCESS';
export const SEND_BULK_PUSH_NOTIFICATION_ERROR =
  'SEND_BULK_PUSH_NOTIFICATION_ERROR';
